<template>
    <div class="shareDetails">
        <img :src="urlPath ? urlPath : treatmentDetail.urlPath" class="image" alt="">
        <p class="copywrit">{{treatmentDetail.content}}</p>
        <p class="download">下载量：{{treatmentDetail.download}}次</p>
        <div class="btnView">
            <Button>编辑信息</Button>
            <Button @click="copy" :data-clipboard-text="treatmentDetail.content" class="copy">复制文案</Button>
            <Button>长按图片保存</Button>
        </div>
    </div>
</template>

<script>
    /*
    * 合成文案
    * */
    import {Button} from 'vant'
    import {treatmentDetail, treatmentComposite} from "../../../../api/share";
    import Clipboard from 'clipboard';

    export default {
        name: "ShareDetails",
        components: {
            Button
        },
        data() {
            return {
                id: '',
                treatmentDetail: {},
                urlPath: ''
            }
        },
        created() {
            this.id = this.$route.params.id;
            treatmentDetail(this.id).then(res => {
                this.treatmentDetail = res;
            });
            treatmentComposite(this.id).then(res => {
                this.urlPath = res;
            })
        },
        methods: {
            copy() {
                let clipboard = new Clipboard('.copy');
                let _this = this;
                clipboard.on('success', e => {
                    _this.toast({
                        text: '复制成功',
                        icon: 'success'
                    });
                    // 释放内存
                    clipboard.destroy()
                });
                clipboard.on('error', e => {
                    // 不支持复制
                    console.log('该浏览器不支持自动复制');
                    // 释放内存
                    clipboard.destroy()
                });
            },
        }
    }
</script>

<style lang='less' scoped>
    .shareDetails {
        padding: 4vw;
        min-height: 100vh;
        background-color: #f9f9fb;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;

        .image {
            display: block;
            width: 70.53vw;
            height: 125.33vw;
            margin: 0 auto;
        }

        .copywrit {
            width: 68.4vw;
            margin: 3.87vw auto 0;
            font-size: 3.73vw;
            color: #1c1c1c;
            text-align: center;
        }

        .download {
            margin-bottom: 2.8vw;
            text-align: center;
            line-height: 8vw;
            font-size: 3.2vw;
            color: #979797;
        }

        .btnView {
            display: flex;
            justify-content: space-between;
            padding: 0 9.6vw;

            button {
                width: 22.5vw;
                height: 7.87vw;
                padding: 0;
                border: none;
                line-height: 7.87vw;
                background-color: #43a2fe;
                border-radius: 1.2vw;
                font-size: 3.47vw;
                color: #ffffff;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/mine/share/details/ShareDetails.vue